import { useState } from "react";
import { apiPost } from "../../lib/api";
import { Button } from "../ui/Button";

// Card payments are paused, not abandoned: no real Stripe keys are
// configured yet (see STRIPE_SECRET_KEY / STRIPE_WEBHOOK_SECRET in
// services/chain-data-api/.env.example). The checkout flow below is
// otherwise complete — flip this back to true once real keys are in place.
const CARD_PAYMENTS_ENABLED = false;

export default function StripePayButton({ planId, customerEmail }: { planId: string; customerEmail: string }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function startCheckout() {
    setError(null);
    setLoading(true);
    try {
      const { checkoutUrl } = await apiPost<{ checkoutUrl: string }>("/api/billing/checkout", {
        planId,
        customerEmail,
        successUrl: `${window.location.origin}${window.location.pathname}?paid=1`,
        cancelUrl: window.location.href,
      });
      window.location.href = checkoutUrl;
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
      setLoading(false);
    }
  }

  if (!CARD_PAYMENTS_ENABLED) {
    return (
      <Button variant="ghost" disabled title="Card payment isn't set up yet — pay with Bitcoin instead.">
        Card payment — coming soon
      </Button>
    );
  }

  return (
    <div>
      <Button onClick={startCheckout} disabled={loading}>
        {loading ? "Redirecting…" : "Pay with card"}
      </Button>
      {error && <p className="mt-2 text-xs text-red-400">{error}</p>}
    </div>
  );
}
